// removed by extract-text-webpack-plugin
module.exports = {"container":"zRmKjAyzDYJruVQYAEih9","content":"_3eIV1nTcbL4dtpOOco4MdX","card":"_1LdxEVKjaOjMFa0EcTyIxm","head":"ATCbG-mw4Qge4m28t61WU","type":"_32UxbTiZYLmcpHRdWYvwsY","time":"_1NbU41UiefL8HHF1YFVBD3"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Payment/PaymentHistory.scss
// module id = 1148
// module chunks = 0